/* GG Hobby — sell-appointment booking form (front end)
   Posts to window.GG_BOOK_API (the Cloudflare Worker). Until that's live, it falls back to a
   prefilled email so no request is lost.
   Rules: Mon–Fri only · 11am–6pm · 30-min slots · LUNCH 12–1 (no slots) ·
          same-day needs 1h notice · booked slots are greyed out (live availability). */
(function () {
  "use strict";

  var I18N = window.GG_I18N || {};
  function tr(s) { return I18N[s] || s; }

  /* Slot rules, published BEFORE the early return below so they're available on every page —
     the chat widget quotes the buying hours from here rather than keeping its own copy that
     could drift from what the form actually offers. This object is the single client-side
     source of truth; change the hours here and both the form and the bot follow. */
  var RULES = window.GG_BOOK_RULES = {
    OPEN_MIN: 11 * 60,        // 11:00
    CLOSE_MIN: 18 * 60,       // 18:00 (last slot starts 17:30)
    SLOT_MINUTES: 30,
    LUNCH_START: 12 * 60,     // 12:00 — no appointments 12–1
    LUNCH_END: 13 * 60,       // 13:00
    MIN_NOTICE_MIN: 60,       // same-day bookings need 1 hour's notice
    LATE_GRACE_MIN: 15,       // late-arrival grace we STATE to customers (ANTIABUSE-SPEC §7).
                              // NOTICE ONLY — nothing auto-cancels; the shop decides at the counter.
                              // Also in worker/gg-booking-worker.js LATE_GRACE_MIN (confirmation email).
    WEEKDAYS_ONLY: true,      // Mon–Fri — the warehouse takes no weekend appointments
    WAREHOUSE: "13201 NE 16th Ave, North Miami, FL 33161",
    EMAIL: "gghobbycard@gmail.com",
  };

  // Stamp the grace period into the policy copy. The pages ship the number as static text too, so
  // it still reads correctly with JS off / to a crawler — this just keeps every mention in sync
  // with RULES above when the operator tunes it. Runs BEFORE the no-form bail-out below, because
  // the FAQ copy lives on the home page where there is no booking form.
  var graceEls = document.querySelectorAll("[data-late-grace]");
  for (var gi = 0; gi < graceEls.length; gi++) graceEls[gi].textContent = RULES.LATE_GRACE_MIN;

  var form = document.getElementById("bookForm");
  if (!form) return;

  var dateInput = document.getElementById("bDate");
  var dateErr = document.getElementById("bDateErr");
  var slotsWrap = document.getElementById("bSlots");
  var timeInput = document.getElementById("bTime");
  var status = document.getElementById("bStatus");
  var submitBtn = document.getElementById("bSubmit");

  // ---- config (the numbers live in RULES above — don't re-declare them here) ----
  var OPEN_MIN = RULES.OPEN_MIN;
  var CLOSE_MIN = RULES.CLOSE_MIN;
  var SLOT_MINUTES = RULES.SLOT_MINUTES;
  var LUNCH_START = RULES.LUNCH_START;
  var LUNCH_END = RULES.LUNCH_END;
  var MIN_NOTICE_MIN = RULES.MIN_NOTICE_MIN;
  var SHOP_EMAIL = RULES.EMAIL;
  // versioned id of the consent copy shown next to the OPTIONAL SMS checkbox — stored server-side
  // as proof of exactly what the customer agreed to. Bump the version if the wording ever changes.
  // (A2P 10DLC rule, Twilio error 30923: SMS consent must be voluntary — it can never be a
  // condition of booking. Confirmations always go out by email; texts only to who ticked the box.)
  var CONSENT_TEXT = "appt-sms-v2 (optional): I agree that GG Hobby may text me (SMS) about this appointment - confirmation, reminders, and changes. Consent is not a condition of booking; message frequency varies; msg & data rates may apply; reply STOP to opt out, HELP for help.";
  // Spanish pages record their own versioned consent copy (matching what the customer actually
  // read) — never runtime-translate a consent record, always version it.
  if (document.documentElement.lang === "es") {
    CONSENT_TEXT = "appt-sms-es-v2 (opcional): Acepto que GG Hobby me envie mensajes de texto (SMS) sobre esta cita - confirmacion, recordatorios y cambios. El consentimiento no es un requisito para reservar; la frecuencia de mensajes varia; pueden aplicar tarifas de mensajes y datos; responde STOP para darte de baja, HELP para ayuda.";
  }

  // ---- Turnstile bot-check (active only when window.GG_TURNSTILE_KEY is set) ----
  var turnstileToken = "";
  if (window.GG_TURNSTILE_KEY && document.getElementById("bTurnstile")) {
    var ts = document.createElement("script");
    ts.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?onload=ggTurnstileReady";
    ts.async = true;
    window.ggTurnstileReady = function () {
      window.turnstile.render("#bTurnstile", {
        sitekey: window.GG_TURNSTILE_KEY,
        theme: "dark",
        callback: function (token) { turnstileToken = token; },
        "expired-callback": function () { turnstileToken = ""; },
      });
    };
    document.head.appendChild(ts);
  }

  // ---- current time in Eastern (shop time), regardless of visitor's timezone ----
  function nowET() {
    var parts = new Intl.DateTimeFormat("en-US", {
      timeZone: "America/New_York", year: "numeric", month: "2-digit",
      day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false
    }).formatToParts(new Date());
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    var hr = o.hour === "24" ? 0 : parseInt(o.hour, 10);
    return { date: o.year + "-" + o.month + "-" + o.day, minutes: hr * 60 + parseInt(o.minute, 10) };
  }
  dateInput.min = nowET().date;

  function label(min) {
    var h = Math.floor(min / 60), m = min % 60;
    var ampm = h >= 12 ? "PM" : "AM";
    var h12 = h % 12 === 0 ? 12 : h % 12;
    return h12 + ":" + String(m).padStart(2, "0") + " " + ampm;
  }

  // ---- render slots (skipping the lunch hour) ----
  (function buildSlots() {
    for (var t = OPEN_MIN; t < CLOSE_MIN; t += SLOT_MINUTES) {
      if (t >= LUNCH_START && t < LUNCH_END) continue; // lunch — no slot
      var b = document.createElement("button");
      b.type = "button";
      b.className = "book__slot";
      b.textContent = label(t);
      b.dataset.value = label(t);
      b.dataset.min = String(t);
      b.addEventListener("click", function () {
        if (this.disabled) return;
        var prev = slotsWrap.querySelector(".is-selected");
        if (prev) prev.classList.remove("is-selected");
        this.classList.add("is-selected");
        timeInput.value = this.dataset.value;
      });
      slotsWrap.appendChild(b);
    }
  })();

  function isWeekday(value) {
    if (!value) return false;
    var parts = value.split("-");
    var d = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
    var day = d.getDay();
    return day >= 1 && day <= 5;
  }

  // ---- enable/disable slots for the chosen date ----
  function applyAvailability(dateStr, busyList) {
    var et = nowET();
    var isToday = dateStr === et.date;
    var busy = busyList || [];
    var slots = slotsWrap.querySelectorAll(".book__slot");
    slots.forEach(function (b) {
      var t = parseInt(b.dataset.min, 10);
      var off = false;
      if (isToday && t < et.minutes + MIN_NOTICE_MIN) off = true;   // too soon today
      if (busy.indexOf(b.dataset.value) !== -1) off = true;          // already booked
      b.disabled = off;
      b.classList.toggle("is-off", off);
      if (off && b.classList.contains("is-selected")) {
        b.classList.remove("is-selected");
        timeInput.value = "";
      }
    });
    applyPreselect();   // runs on both passes: the sync rules pass and the live-availability one
  }

  // ---- live availability from the backend (greys out booked slots) ----
  function loadAvailability(dateStr) {
    applyAvailability(dateStr, []); // same-day/notice rules first
    if (!window.GG_BOOK_API) return;
    var url = window.GG_BOOK_API + (window.GG_BOOK_API.indexOf("?") === -1 ? "?" : "&") + "date=" + encodeURIComponent(dateStr);
    fetch(url, { method: "GET" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) { if (data && data.busy) applyAvailability(dateStr, data.busy); })
      .catch(function () { /* availability is best-effort; submit still conflict-checks */ });
  }

  dateInput.addEventListener("change", function () {
    var ok = isWeekday(dateInput.value);
    dateErr.hidden = ok || !dateInput.value;
    if (!ok && dateInput.value) { dateInput.value = ""; timeInput.value = ""; wantSlot = ""; return; }
    if (dateInput.value) loadAvailability(dateInput.value);
  });

  /* ---- deep link from the chat widget (v10): ?d=YYYY-MM-DD&t=1:00%20PM lands the seller
     here with the day + slot already picked, so the estimator + identity fields are all
     that's left. The slot is validated by the SAME path as a manual pick — it's only
     selected if buildSlots() rendered it (so never a lunch slot) and applyAvailability left
     it enabled (so never a past, too-soon, or already-booked time). A stale or hand-edited
     link therefore degrades to a normal empty form rather than booking a bad time. ---- */
  var wantSlot = "";
  function applyPreselect() {
    if (!wantSlot || timeInput.value) return;   // nothing pending, or the user already chose
    var all = slotsWrap.querySelectorAll(".book__slot");
    for (var i = 0; i < all.length; i++) {
      if (all[i].dataset.value === wantSlot) {
        if (!all[i].disabled) all[i].click();
        return;
      }
    }
  }
  (function preselectFromUrl() {
    var q = new URLSearchParams(window.location.search);
    var d = (q.get("d") || "").trim();
    if (!/^\d{4}-\d{2}-\d{2}$/.test(d) || !isWeekday(d) || d < nowET().date) return;
    dateInput.value = d;
    dateErr.hidden = true;
    wantSlot = (q.get("t") || "").trim();
    loadAvailability(d);
  })();

  function mailtoFallback(p) {
    var body =
      encodeURIComponent(tr("SELL APPOINTMENT REQUEST")) + "%0A%0A" +
      encodeURIComponent(tr("Name: ") + p.name) + "%0A" +
      encodeURIComponent(tr("Phone: ") + p.phone) + "%0A" +
      encodeURIComponent(tr("Email: ") + p.email) + "%0A" +
      encodeURIComponent(tr("Requested: ") + tr("{date} at {time}").replace("{date}", p.date).replace("{time}", p.time)) + "%0A" +
      encodeURIComponent(tr("Bringing: ") + (p.items || tr("(not listed)"))) + "%0A" +
      encodeURIComponent(tr("SMS consent: ") + (p.consentComms ? tr("YES - ") + p.consentText : tr("no"))) + "%0A";
    return "mailto:" + SHOP_EMAIL +
      "?subject=" + encodeURIComponent(tr("Sell Appointment — {name}").replace("{name}", p.name)) +
      "&body=" + body;
  }

  function setStatus(msg, kind) {
    status.textContent = msg;
    status.className = "book__status" + (kind ? " book__status--" + kind : "");
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    var p = {
      name: document.getElementById("bName").value.trim(),
      phone: document.getElementById("bPhone").value.trim(),
      email: document.getElementById("bEmail").value.trim(),
      date: dateInput.value,
      time: timeInput.value,
      items: document.getElementById("bItems").value.trim()
    };
    var agreed = document.getElementById("bAgree").checked;
    var consentBox = document.getElementById("bConsent");
    var consented = consentBox ? consentBox.checked : false;

    if (!p.date || !isWeekday(p.date)) { setStatus(tr("Please pick a weekday (Mon–Fri)."), "err"); dateInput.focus(); return; }
    if (!p.time) { setStatus(tr("Please pick an available time slot."), "err"); return; }
    if (!p.name || !p.email) { setStatus(tr("Please fill in your name and email."), "err"); return; }
    // Checks are written to the seller's FULL legal name (owner rule 2026-08-18):
    // require first AND last — one word can't go on a check. The Worker enforces
    // the same rule server-side; this mirror gives the instant message.
    var nameWords = p.name.split(/\s+/).filter(function (w) { return w.replace(/[^A-Za-zÀ-ÿ'.\-]/g, "").length >= 2; });
    if (nameWords.length < 2) {
      setStatus(tr("We pay by check — please enter your FIRST and LAST name (both), exactly as your check should read."), "err");
      document.getElementById("bName").focus(); return;
    }
    // real contact info only — the Worker enforces the same rules server-side; these
    // mirrors just give an instant, friendlier message before the round-trip
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(p.email)) {
      setStatus(tr("Please enter a real email address (like name@example.com) — your confirmation goes there."), "err");
      document.getElementById("bEmail").focus(); return;
    }
    // phone is OPTIONAL — validate the format only when one was left
    if (p.phone) {
      var phoneDigits = p.phone.replace(/\D/g, "");
      if (phoneDigits.length === 11 && phoneDigits.charAt(0) === "1") phoneDigits = phoneDigits.slice(1);
      if (phoneDigits.length !== 10 || /^(\d)\1{9}$/.test(phoneDigits)) {
        setStatus(tr("Please enter a real 10-digit US phone number — or leave the phone field blank."), "err");
        document.getElementById("bPhone").focus(); return;
      }
    }
    if (!agreed) { setStatus(tr("Please confirm you've read what's accepted and you'll keep your appointment."), "err"); return; }

    // MANDATORY item list (owner rule 2026-08-10): the booking must carry the estimator's
    // structured list — intake preps from the catalog matches, so free-text-only bookings are
    // out. The Worker enforces the same rule server-side (stale cached pages hit that wall);
    // this mirror gives the instant, friendlier message. bItems stays as a supplement for
    // items the catalog doesn't carry.
    var estItems = Array.isArray(window.GG_EST_ITEMS) ? window.GG_EST_ITEMS : [];
    if (!estItems.length) {
      setStatus(tr("One more step: bookings now need your item list. Scroll up to the estimator, add what you're bringing, and tap “Book an Appointment With This List” — anything we don't list can go in the extra-items box."), "err");
      return;
    }

    // SMS consent is OPTIONAL and never blocks the booking (A2P 10DLC / Twilio 30923).
    // Record exactly what was chosen; the Worker only ever texts customers who opted in.
    p.consentComms = consented;
    if (consented) p.consentText = CONSENT_TEXT;

    // MARKETING email opt-in — separate consent from appointment comms (EMAIL-MARKETING.md).
    // Optional and unchecked; true feeds the promo list server-side, absent/false changes nothing.
    var promoBox = document.getElementById("bPromo");
    p.promoOptIn = promoBox ? promoBox.checked : false;

    // structured item list from the estimator (name/qty/market/sku/upc) — rides along so the
    // shop's intake system can prep the order before the seller arrives
    p.itemsData = estItems;

    // anti-abuse: honeypot value (blank for humans) + Turnstile token when the widget is active
    p.website = (document.getElementById("bWebsite") || { value: "" }).value;
    if (window.GG_TURNSTILE_KEY) {
      if (!turnstileToken) { setStatus(tr("Please wait for the security check to finish, then try again."), "err"); return; }
      p.turnstileToken = turnstileToken;
    }

    submitBtn.disabled = true;
    setStatus(tr("Sending your request…"));

    var endpoint = window.GG_BOOK_API || "/api/book";
    fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(p)
    })
      .then(function (res) {
        if (res.status === 409) throw new Error("taken");
        if (!res.ok) {
          // surface the server's real reason (turnstile / rate limit / validation) instead of
          // silently falling back to email
          return res.json().then(function (body) {
            var e = new Error(body && body.error ? body.error : "status " + res.status);
            e.isServerMessage = true;
            throw e;
          }, function () { throw new Error("status " + res.status); });
        }
        return res.json();
      })
      .then(function () {
        // The address only renders AFTER a confirmed booking — the sell pages themselves
        // never show it (owner rule: no walk-ins at the store OR the warehouse).
        var mapsUrl = "https://www.google.com/maps/dir/?api=1&destination=" +
          encodeURIComponent("13201 NE 16th Ave, North Miami, FL 33161");
        form.innerHTML =
          '<div class="book__done">' +
          '<div class="book__done-check">✓</div>' +
          "<h3>" + tr("You're on the books!") + "</h3>" +
          "<p>" + tr("We've got your request for <strong>{date} at {time}</strong>. Check your email for confirmation — see you then.")
            .replace("{date}", p.date).replace("{time}", p.time) + "</p>" +
          '<div class="book__done-where">' +
          '<p class="book__done-warn">' + tr("📍 Come to our WAREHOUSE — NOT the GG Hobby store in Aventura.") + "</p>" +
          '<p class="book__done-addr"><strong>GG Hobby — Sell Warehouse</strong><br>13201 NE 16th Ave<br>North Miami, FL 33161</p>' +
          '<a class="book__done-dir" href="' + mapsUrl + '" target="_blank" rel="noopener">' + tr("Get Directions") + "</a>" +
          "</div>" +
          "</div>";
      })
      .catch(function (err) {
        if (err && err.message === "taken") {
          setStatus(tr("That time was just booked — please pick another slot."), "err");
          loadAvailability(p.date);
          submitBtn.disabled = false;
          return;
        }
        if (err && err.isServerMessage) {
          // the backend answered with a real reason — show it, don't detour to email
          setStatus(err.message, "err");
          submitBtn.disabled = false;
          return;
        }
        // backend truly unreachable — keep the request flowing via email
        setStatus(tr("Opening an email so we still get your request…"), "warn");
        window.location.href = mailtoFallback(p);
        submitBtn.disabled = false;
      });
  });
})();

/* ---- buying switch (v8): the owner can pause buying site-wide via the Worker.
   GET /api/buying -> { enabled:false } hides every [data-sell-gate] element (nav links,
   homepage sell band, hero sell button, FAQ buy item, and the sell/book sections on the
   sell page) and reveals #buyingPaused instead. Fails OPEN: if the endpoint is missing or
   unreachable, the sell funnel stays visible — the Worker still rejects bookings server-side. */
(function () {
  "use strict";
  if (!window.GG_BOOK_API) return;
  var api = String(window.GG_BOOK_API).replace(/\/api\/book\/?$/, "/api/buying");
  if (api === String(window.GG_BOOK_API)) return;
  fetch(api)
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (state) {
      if (!state || state.enabled !== false) return; // buying on (or unknown) -> leave everything alone
      Array.prototype.forEach.call(document.querySelectorAll("[data-sell-gate]"), function (el) {
        el.style.display = "none";
      });
      // swap-style elements: FAQ buy answer etc. show a "paused" message instead of vanishing
      Array.prototype.forEach.call(document.querySelectorAll("[data-buying-on]"), function (el) {
        el.hidden = true;
      });
      Array.prototype.forEach.call(document.querySelectorAll("[data-buying-off]"), function (el) {
        el.hidden = false;
      });
      var paused = document.getElementById("buyingPaused");
      if (paused) {
        paused.hidden = false;
        if (state.note) {
          var note = document.getElementById("buyingPausedNote");
          if (note) note.textContent = state.note;
        }
      }
      // the owner's custom pause notice (typed in the POS toggle) also replaces the FAQ's
      // default first sentence, so the site says exactly what the program says
      if (state.note) {
        Array.prototype.forEach.call(document.querySelectorAll("[data-buying-note]"), function (el) {
          el.textContent = state.note;
        });
      }
    })
    .catch(function () { /* unreachable -> fail open */ });
})();

/* ---- buying wait-list form (v9): lives inside #buyingPaused on the sell page.
   POSTs to /api/buying/notify; the Worker stores {email, phone?} and, when the owner
   flips buying back ON with notify:true, everyone gets one email (+ one text w/ STOP
   line if they left a number) and the list clears. ---- */
(function () {
  "use strict";
  var I18N = window.GG_I18N || {};
  function tr(s) { return I18N[s] || s; }
  var form = document.getElementById("buyWaitForm");
  if (!form || !window.GG_BOOK_API) return;
  var api = String(window.GG_BOOK_API).replace(/\/api\/book\/?$/, "/api/buying/notify");
  if (api === String(window.GG_BOOK_API)) return;
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var status = document.getElementById("bwStatus");
    var btn = form.querySelector("button[type=submit]");
    var say = function (t, kind) {
      if (status) { status.textContent = t; status.className = "book__status" + (kind ? " book__status--" + kind : ""); }
    };
    var email = ((document.getElementById("bwEmail") || {}).value || "").trim();
    var phone = ((document.getElementById("bwPhone") || {}).value || "").trim();
    var hp = (document.getElementById("bwHp") || {}).value || "";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { say(tr("Enter a valid email."), "err"); return; }
    if (btn) btn.disabled = true;
    fetch(api, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: email, phone: phone, website: hp }),
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }).catch(function () { return { ok: r.ok, j: {} }; }); })
      .then(function (res) {
        if (!res.ok) {
          say((res.j && res.j.error) || tr("Something went wrong — try again."), "err");
          if (btn) btn.disabled = false;
          return;
        }
        say(tr("You're on the list — we'll hit you the second buying reopens."), "ok");
        form.reset();
      })
      .catch(function () {
        say(tr("Couldn't reach the server — try again in a minute."), "err");
        if (btn) btn.disabled = false;
      });
  });
})();
